import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=3fc69452&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc69452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fc69452')) {
      api.createRecord('3fc69452', component.options)
    } else {
      api.reload('3fc69452', component.options)
    }
    module.hot.accept("./Show.vue?vue&type=template&id=3fc69452&scoped=true&", function () {
      api.rerender('3fc69452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/User/Show.vue"
export default component.exports